import GemQuery from './utils/GemQuery';

export {};
declare global {
  interface Window {
    GemQuery: JQueryStatic;
  }
}
(function (jQuery) {
  /**
   * Function to reset transformation from element to it's parents
   *
   * @param element selector of jQuery
   * @returns {jQuery} elemnent
   */
  (jQuery as any).positionFixed = function (element: Element) {
    jQuery(element)
      .parents()
      .map(function () {
        // const transform = jQuery(this).css("transform");
        // if (transform && !["none", "", "initial"].includes(transform)) {
        const $this = jQuery(this);
        $this.css({ transform: 'none', zIndex: 50 });
        // }
      });
    return this;
  };

  /**
   * jQuery add plugin
   * @returns jQuery element
   */
  (jQuery.fn as any).positionFixed = function () {
    return (this as JQuery).each(function () {
      (jQuery as any).positionFixed(this);
    });
  };
})(GemQuery);
